export const config = {
    dev: {
        baseUrl: 'http://localhost:7060',
    },
    prod: {
        baseUrl: 'https://socialmart.com',
    },
};

export const PERCEPT_API_KEY = 'ff1614110dc8089aaf73f33ed470427cf3d618be48ebed28c66d57ec61c24289';